import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'fc-skeleton',
  template: ``,
  styleUrls: ['./skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SkeletonComponent {
  @HostBinding('style.width') @Input() width: string = '50px';
  @HostBinding('style.height') @Input() height: string = '50px';
  @HostBinding('class') @Input() animation: 'wave' | 'pulse' = 'wave';
  @Input() shape: 'rectangle' | 'circle' | 'text' = 'rectangle';

  @HostBinding('class.circle') get circleClass() {
    return this.shape === 'circle';
  }

  @HostBinding('class.rectangle') get rectangleClass() {
    return this.shape === 'rectangle';
  }

  @HostBinding('class.text') get textClass() {
    return this.shape === 'text';
  }
}
